export enum ProfileTypeEnum {
  both = 0,
  individual = 1,
  business = 2,
}
